import React from 'react';
import PropTypes from 'prop-types';
import CwImage from '../cwimage/CwImage';
import css from './Header.scss';
import moment from 'moment';

/**
 * The head rests atop the calendar and deals with month changes and
 * displays month and year information.
 */
const Header = (props) => {

	//Move the date back a year
	const leftArrowClick = () => {
		const date = props.value;
		date.month(date.month() - 1);
		props.onClick(date);
	};

	//Move the date forward a year
	const rightArrowClick = () => {
		const date = props.value;
		date.month(date.month() + 1);
		props.onClick(date);
	};

	const date = props.value;
	const month = date.month();
	const year = date.year();

	return (
		<div className={css.header}>
			<CwImage src={props.leftArrow} onClick={leftArrowClick} height={16} width={16} />
			<label className={css.monthYear}>{props.monthName[month]} {year}</label>
			<CwImage src={props.rightArrow} onClick={rightArrowClick} height={16} width={16} />
		</div>
	);
};

Header.propTypes = {
  /**
   * A working instance of a moment Object. Note that this value is not the same as the "value" displayed in the
   * DatePicker's text field but instead should represent the date associated with the state in CwDatePicker.
   */
	value: PropTypes.instanceOf(moment),
  /**
   * An array of localized months
   */
	monthName: PropTypes.array,
  /**
   * url for the left arrow image
   */
	leftArrow: PropTypes.string,
  /**
   * url for the right arrow image
   */
	rightArrow: PropTypes.string,
  /**
   * A function responsible for handling the arrow clicks in the header
   */
	onClick: PropTypes.func,
};

Header.defaultProps = {
	monthName: ["January", "February", "March", "April", "May", "June",
		"July", "August", "September", "October", "November", "December"
	]
};

export default Header;


// WEBPACK FOOTER //
// ./src/components/cwdatepicker/Header.jsx